export class AgencyPrincipalContactRequest {
    public firstName: string;
    public lastName: string;
    public preferredContactMethod: 'Email' | 'PhoneCall' | 'TextMessage';
    public email: string;
    public phoneNumber: string;
    public postalCode: string;
    public message: string;
}